export const environment = {
  production: false,
  BASE_URL: 'https://api.djs.mk/api',
  // BASE_URL: 'http://api.functionalplanet.mk/api',
};
